import { render, staticRenderFns } from "./scaleType.vue?vue&type=template&id=44691df5&scoped=true&"
import script from "./scaleType.vue?vue&type=script&lang=js&"
export * from "./scaleType.vue?vue&type=script&lang=js&"
import style0 from "./scaleType.vue?vue&type=style&index=0&id=44691df5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44691df5",
  null
  
)

export default component.exports